<style>
    .success-wrapper {
        font-family: 'Nunito Sans', sans-serif;
        position: relative;
        overflow: hidden;
        background-color: #00ff0044;
        /* dark green with transparency */
        border-radius: 4px;
        width: 280px;
        aspect-ratio: 2;
        color: white;
        z-index: 1;
        ;
    }

    .success-content {
        display: flex;
        height: 100%;
        flex-direction: column;
    }

    .success-message-container {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 15px;
    }

    .success-message {
        background-color: #00aa0055;
        /* light green */
        flex: 1 1 auto;
        padding: 15px;
    }

    .success-header {
        background-color: #00aa0055;
        box-sizing: border-box;
        width: 100%;
        padding: 15px;
        display: flex;
        justify-content: space-between;
    }

    .success-between {
        background-color: #fff;
        position: relative;
        height: 1px;
        width: 100%;
    }

    .success-shadow {
        position: absolute;
        width: 33%;
        top: -5%;
        height: 50%;
        right: -5%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: -1;
    }

    .hexagon {
        width: 100%;
        height: 100%;
        background-color: #004d0044;
        clip-path: polygon(0% 0%, 100% 0%, 100% 75%, 66% 100%, 33% 100%, 0% 75%);
    }

    .middle-svg-icon,
    .middle-svg-icon svg {
        height: 100%;
        width: 100%;
    }
</style>



<div class="success-wrapper">
    <div class="success-content">
        <div class="success-header">
            <div class="success-title">Success</div>
            <div class="success-close">x</div>
        </div>
        <div class="success-between"></div>
        <div class="success-message">
            {{data?.message ?? data}}
        </div>
    </div>
    <div class="success-shadow">
        <div class="hexagon">
            <div class="middle-svg-icon">
                <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <!-- Checkmark -->
                    <polyline points="25,50 45,70 75,30" fill="none" stroke="#00ff00" stroke-width="10"
                        stroke-linecap="round" stroke-linejoin="round">
                        <animate attributeName="points" from="25,50 25,50 25,50" to="25,50 45,70 75,30" dur="0.5s"
                            fill="freeze" />
                    </polyline>
                </svg>
            </div>
        </div>
    </div>
</div>